import React from "react";

function TokenInButton({ count, theme = "dark" }) {
    return <></>;
    return (
        <span
            style={{
                border: `1px solid ${theme === "dark" ? "white" : "#00998e"}`,
                borderRadius: "20px",
                padding: "1px 6px",
                // backgroundColor: theme === "dark" ? "#fffb" : "#00998e",
                color: theme === "dark" ? "white" : "#00998e",
                lineHeight: "normal",
            }}
        >
            {count}
        </span>
    );
}

export default TokenInButton;
